<template>
  <Print v-if="isPrint" :board="board" :form="form" :header="header" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :readonly="board.readonly"
      :types="['writer_name', 'phone', 'date']"
      :typeslabel="{
        writer_name: '작성자',
        phone: '작성자 전화번호',
        date: '작성일',
      }"
    />

    <div>
      <h5 class="my-4"><i class="dot"></i> Ⅰ. 건설업체 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>①연 번</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.연번 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.연번"/>
        </div>
        <div>
          <div>현장명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.현장명 }}</p>
          <company-selector v-else :readonly="board.readonly" v-model="form.현장명.id" @select="(company) => {form.현장명.id = company.id; form.현장명.com_name = company.com_name}"/>
        </div>
        <div>
          <div>방문일시</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.방문일시 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.방문일시" />
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>②사업장관리번호<br>(사업개시번호)</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.사업장관리번호 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.사업장관리번호"/>
        </div>
        <div>
          <div>소재지</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.소재지 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.소재지"/>
        </div>
        <div>
          <div>공사금액<br>(VAT 포함)</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.공사금액 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.공사금액"/>
        </div>
      </div>
    </div>


    <div class="mt-28px">
      <h5 class="mt-4"><i class="dot"></i> Ⅱ. 사업주 안전·보건활동 현황</h5>

      <table-custom
        :board="board"
        :is-print="isPrint"
        title=""
        :tableData="[
          { id: 'no', title: '연번', type: 'no', width: '80px' },
          { id: '소속', title: '소속', type: 'text', placeholder: '' },
          { id: '직급', title: '직급', type: 'text', placeholder: '' },
          { id: '성명', title: '성명', type: 'text', placeholder: '' },
        ]"
        :mobile="['no', '현장명', '사업개시번호']"
        v-model="form.안전보건간담회_본사"
      >
        <template #customTitle>
          <h5>-본사</h5>
        </template>
      </table-custom>

      <table-custom
        :board="board"
        :is-print="isPrint"
        title=""
        :tableData="[
          { id: 'no', title: '연번', type: 'no', width: '80px' },
          { id: '소속', title: '소속', type: 'text', placeholder: '' },
          { id: '직급', title: '직급', type: 'text', placeholder: '' },
          { id: '성명', title: '성명', type: 'text', placeholder: '' },
        ]"
        :mobile="['no', '현장명', '사업개시번호']"
        v-model="form.안전보건간담회_현장"
      >
        <template #customTitle>
          <h5>-현장</h5>
        </template>
      </table-custom>

      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>③주요 내용</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.주요내용 }}</p>
          <ml-textarea v-else :readonly="board.readonly" v-model="form.주요내용" placeholder=" □ 일일 TBM 실시여부 및 위험성평가 공유

 □ 안전보건법령 관련 지도 조언

 □ 현장 안전점검 실시

 □ 혹서기 대비 온열질환 사고 사전방지"/>
        </div>
        <div class="writeGridLineItem">
          <div>간담회 사진</div>
          <div>
            <div style="max-width: 444px; height: 303px">
              <p v-if="isPrint" class="print-input flex-1">{{ form.간담회사진 }}</p>
              <file-uploader v-model="form.간담회사진" id="imageSign" type="only-image" />
            </div>
          </div>
        </div>

      </div>
    </div>

    <table-inspect-merge
      title="Ⅲ. 현장 안전·보건활동"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      tableHeaderTitle="안전·보건활동 항목"
      :tableHeaderCheck="[
        { text: '이행', width: '300px' },
        { text: '미이행', width: '300px' },
      ]"
      :tableHeaderNote="[]"
      contentBefore="•"
      v-model="form.안전보건활동"
      class="mt-5"
    />
    <div class="writeGridLineItem">
      <div>④참고자료</div>
      <p v-if="isPrint" class="print-input flex-1">{{ form.참고자료 }}</p>
      <ml-textarea v-else :readonly="board.readonly" v-model="form.참고자료" placeholder="- 온열질환 사고 방지

- 근로자 쉼터 설치

- 휴게시간 확대 (40분 작업 + 20분 휴식)"/>
    </div>


    <div class="mt-28px">
      <h5 class="mt-4"><i class="dot"></i> Ⅳ. 현장 위험요인 점검</h5>

      <table-custom
        :board="board"
        :is-print="isPrint"
        title=""
        :tableData="[
          { id: 'no', title: '연번', type: 'no', width: '80px' },
          { id: '소속', title: '소속', type: 'text', placeholder: '' },
          { id: '직급', title: '직급', type: 'text', placeholder: '' },
          { id: '성명', title: '성명', type: 'text', placeholder: '' },
        ]"
        :mobile="['no', '현장명', '사업개시번호']"
        v-model="form.위험요인점검_본사"
      >
        <template #customTitle>
          <h5>-본사</h5>
        </template>
      </table-custom>

      <table-custom
        :board="board"
        :is-print="isPrint"
        title=""
        :tableData="[
          { id: 'no', title: '연번', type: 'no', width: '80px' },
          { id: '소속', title: '소속', type: 'text', placeholder: '' },
          { id: '직급', title: '직급', type: 'text', placeholder: '' },
          { id: '성명', title: '성명', type: 'text', placeholder: '' },
        ]"
        :mobile="['no', '현장명', '사업개시번호']"
        v-model="form.위험요인점검_현장"
      >
        <template #customTitle>
          <h5>-현장</h5>
        </template>
      </table-custom>

      <table-custom
        :board="board"
        :is-print="isPrint"
        title=""
        :tableData="[
          { id: 'no', title: '연번', type: 'no', width: '80px' },
          { id: '위험요인', title: '⑤위험요인', type: 'text', placeholder: '' },
          { id: '주요점검내용', title: '주요 점검 내용', type: 'text', placeholder: '' },
          { id: '사업주지원대책', title: '사업주 지원 대책<br/>(사업주가 할 수 있는 범위 안에서의 예산·인력·시설 지원 등)', type: 'text', placeholder: '' },
        ]"
        :mobile="['no', '현장명', '사업개시번호']"
        v-model="form.위험요인점검_위험요인"
      >
        <template #customTitle>
          <h5>- 현장 위험요인 점검</h5>
        </template>
      </table-custom>
    </div>

    <div class="mt-6 border-top border-left border-right border-bottom">
      <p class="p-4 border-bottom font-medium text-center">[참고] 건설현장 핵심 위험요인 16종</p>
      <p class="p-4">▴단부·개구부, ▴철골, ▴지붕, ▴비계, ▴사다리, ▴달비계, ▴이동식비계, ▴거푸집동바리, ▴굴착기, ▴고소작업대, ▴트럭, ▴이동식크레인, ▴타워크레인, ▴항타·항발기, ▴용접장치, ▴밀폐공간</p>
    </div>


    <div class="mt-28px">
      <h5 class="mt-4"><i class="dot"></i>보고인</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>사업주</div>
          <ml-input v-if="!isPrint" v-model="form.보고인.사업주" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.보고인.사업주 }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.보고인.서명" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.보고인.서명" :src="form.보고인.서명" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mt-4"><i class="dot"></i>참고</h5>
      <div class="mt-6 border-top border-left border-right border-bottom">
        <p class="p-4 border-bottom font-medium text-center">작성방법</p>
        <p class="p-4">
          ① 연 번: 1쪽 Ⅱ의 각 현장별 연번을 기재합니다.<br>
          ② 사업장관리번호(사업개시번호): 근로복지공단의 산업재해보상보험 가입 시 부여된 도급인 사업장 관리번호(사업개시번호)를 적습니다.<br>
          ③ 주요 내용: 간담회에서 논의된 주요 내용을 작성합니다.<br>
          ④ 참고 자료: 현장 안전·보건활동의 내용을 확인할 수 있는 참고자료를 첨부합니다.<br>
          ⑤ 위험 요인: 현장 순회점검에서 확인한 위험요인을 작성합니다.
        </p>
      </div>
    </div>


    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import Print from "./Print.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import {dataFilter} from "echarts/lib/component/marker/markerHelper";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import FileUploaderImg from "@/components/FileUploaderImg.vue";
import FileUploader from "@/components/FileUploader.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    TableInspectMerge,
    FileUploader,
    FileUploaderImg,
    CompanySelector,
    FieldSelector,
    TimeSelectorRang,
    Print,
    TableCustom,
    TimeSelector,
    RadioGroup,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  data() {
    return {
      isMobile: false,
      showEmployeePopup: false,
      showMemberPopup: false,

      form: {
        stdInfo: {},
        fileList: [],

        field: { id: 0, field_name: '' },

        연번: '',
        현장명: { id: 0, com_name: '' },
        방문일시: '',

        사업장관리번호: '',
        소재지: '',
        공사금액: '',

        안전보건간담회_본사: [],
        안전보건간담회_현장: [],
        주요내용: '',
        간담회사진: [],
        안전보건활동: [
          { content: '안전·보건활동 항목', isChecked: '' },
          { content: '작업 전 안전회의(TBM)', isChecked: '' },
          { content: '산업재해 재발방지대책 수립', isChecked: '' },
          { content: '아차사고 신고제도', isChecked: '' },
          { content: '비상조치계획 수립', isChecked: '' },
        ],
        참고자료: '',
        위험요인점검_본사: [],
        위험요인점검_현장: [],
        위험요인점검_위험요인: [],
        보고인: {
          사업주: '',
          서명: '',
        }
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    handleFieldSelect(field) {
      this.form.field = field;
      if (field && field.id) {
        this.loadField(field.id);
      }
    },
    async loadField(fieldId) {
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.form.대표자 = info.director_name || "";
      this.form.소재지 = info.address || "";
    },
  },
};
</script>
